type TSuperdockShipperLegShape = {
	is_admin_shipment?: boolean;
	admin_shipments?: unknown[] | null;
	superdock_carriers?: unknown[] | null;
};

export const isSuperdockShipperLeg = (shipment?: TSuperdockShipperLegShape | null): boolean => {
	if (!shipment || shipment.is_admin_shipment) {
		return false;
	}
	return Boolean(shipment.superdock_carriers?.length) || Boolean(shipment.admin_shipments?.length);
};
